import { render } from "./ContentList.vue?vue&type=template&id=0b5e88da&scoped=true"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"

import "./ContentList.vue?vue&type=style&index=0&id=0b5e88da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b5e88da"

export default script